import React from 'react'
import { Bars } from 'react-loader-spinner'
import { useSelector } from 'react-redux'
import { dark_mode } from '../../Utility/constants'




const Button = ({ type, title, action, style, disabled, loading }) => {
    const mode = useSelector(state => state.mode)

    return (
        <button style={style} disabled={disabled} className={`button ${type}`} onClick={() => { action() }}>
            {loading ? <span style={{ alignItems: 'center', textAlign: 'center' }}><Bars height="25" width="25" color={mode === dark_mode ? "#EE31AF" : '#ffff'}></Bars></span> : null}{title}
        </button>
    )
}


export default Button